'use strict';

var index_styled = require('./chunks/index.styled2.js');
require('styled-components');
require('@userzoomlibraries/toolkit-js-utils/prop-types');
require('react');
require('@userzoomlibraries/toolkit-js-utils/is-defined-and-not-null');
require('@userzoomlibraries/toolkit-js-utils/noop');
require('@userzoomlibraries/toolkit-js-utils/is-function');
require('@userzoomlibraries/toolkit-js-utils/is-string');
require('@userzoomlibraries/toolkit-js-utils/get-id');
require('@userzoomlibraries/toolkit-js-utils/is-null');
require('@userzoomlibraries/toolkit-js-utils/get-safe-html-element');
require('@userzoomlibraries/toolkit-js-utils/get-scrollable-containers-by-element');
require('@userzoomlibraries/toolkit-react-utils/use-previous');
require('@userzoomlibraries/toolkit-react-utils/use-escape');
require('@userzoomlibraries/toolkit-react-utils/use-on-click-outside');
require('@userzoomlibraries/toolkit-react-utils/use-mutation-observer');
require('@userzoomlibraries/toolkit-react-utils/use-data-attributes');
require('@userzoomlibraries/toolkit-react-utils/use-disable-background-scroll');
require('./chunks/index.styled.js');
require('@userzoomlibraries/toolkit-theme-manager/get-theme-by-props');
require('@userzoomlibraries/toolkit-portal');
require('@userzoomlibraries/toolkit-js-utils/is-number');
require('react/jsx-runtime');
require('@userzoomlibraries/toolkit-js-utils/float-round');
require('@userzoomlibraries/toolkit-js-utils/is-html-element');
require('@userzoomlibraries/toolkit-js-utils/get-visibility-percentage-of-element');
require('@userzoomlibraries/toolkit-js-utils/get-relative-position-to-parent');

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */

module.exports = index_styled.LinkedFloatingElement;
